// This file is auto-generated. Do not edit!

export default [
  {
    name: "axlETH/ETH",
    id: "4",
    bpt: "0x30722f57D56037CAA2C38ABD1F5E2955814875e9",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0xb829b68f57CC546dA7E5806A929e53bE32a4625D",
        symbol: "axlETH",
      },
    ],
    rewarder: "0x35F398F2dbcaDf1cDDDe9602192233715277A7ee",
  },
  {
    name: " 50tBTC-50USD",
    id: "5",
    bpt: "0x036d68e4e0005dA4eF1c9ebd53b948d2C083495e",
    tokens: [
      {
        address: "0x236aa50979D5f3De3Bd1Eeb40E81137F22ab794b",
        symbol: "tBTC",
      },
      {
        address: "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
        symbol: "USDbC",
      },
    ],
    rewarder: "0xde18d8129Ef4B9032e2DF26C5D4f3Ed31BfbF7cd",
  },
  {
    name: "ECLP-AURA-USDC",
    id: "11",
    bpt: "0x5F62fd24941B585b91EB059E0ea1a7e729357511",
    tokens: [
      {
        address: "0x1509706a6c66CA549ff0cB464de88231DDBe213B",
        symbol: "AURA",
      },
      {
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        symbol: "USDC",
      },
    ],
    rewarder: "0xff860c4D5bA79a523B4Cfffda059844DDcbD966e",
  },
  {
    name: "ECLP-cbETH-wstETH",
    id: "13",
    bpt: "0x54D86E177cdC664B5F9B17eB5fd6A76Fa529e466",
    tokens: [
      {
        address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
        symbol: "cbETH",
      },
      {
        address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
        symbol: "wstETH",
      },
    ],
    rewarder: "0x588ee7aD6Dc38176Df272d0e723BeE6161938036",
  },
  {
    name: "20WETH-80IMO",
    id: "18",
    bpt: "0x007bb7a4bfc214DF06474E39142288E99540f2b3",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x5A7a2bf9fFae199f088B25837DcD7E115CF8E1bb",
        symbol: "IMO",
      },
    ],
    rewarder: "0x0Ec191f765C0a1611aB3A4cdB839A66D2033e476",
  },
] as const
